define('../app/fukit/helpers/model.util',['require','exports','module','underscore','backbone','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Promise  = require('bluebird');

  var ModelUtil = {
    resolvePromise: function(xhr) {
      return Promise.resolve(_.result(xhr, 'promise') || xhr);
    },

    safeGet: function(model, attribute) {
      if (model instanceof Backbone.Model) {
        return _.isString(attribute) ? model.get(attribute) : null;
      } else {
        return null;
      }
    },
  };

  module.exports = ModelUtil;
});

